var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.342325 13.4964C-0.150273 12.8717 -0.106002 11.9097 0.441285 11.3475L4.67312 7.00069L0.441285 2.65241C-0.105879 2.09015 -0.150234 1.12815 0.342326 0.503531C0.834956 -0.120908 1.67788 -0.171499 2.22517 0.390589L7.55859 5.86829C7.83954 6.15688 8 6.56929 8 7.00069C7.99985 7.43187 7.83942 7.84314 7.55859 8.1316L2.22517 13.6093C1.67784 14.1715 0.834954 14.121 0.342325 13.4964Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.462f0571f0efa994ef777bb28b45b092.svg";
export { ForwardRef as ReactComponent };